if (!customElements.get('fabric-attributes')) {
  class FabricAttributes extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('[data-fabric-attributes-toggle]');
      this.panel = this.querySelector('.fabric-attributes__panel');
      this.icon = this.querySelector('.fabric-attributes__toggle-icon');
      this.barFills = this.querySelectorAll('[data-fabric-attr-pct]');

      if (!this.toggleButton || !this.panel) return;

      this.setBarWidths(false);
      this.toggleButton.addEventListener('click', this.onToggle);
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.onToggle);
    }

    setBarWidths(open) {
      this.barFills.forEach((fill) => {
        const pct = Number(fill.dataset.fabricAttrPct) || 0;
        fill.style.width = open ? `${pct}%` : '0%';
      });
    }

    onToggle = () => {
      const isOpen = this.classList.toggle('is-open');
      this.toggleButton.setAttribute('aria-expanded', String(isOpen));
      this.panel.setAttribute('aria-hidden', String(!isOpen));

      if (this.icon) {
        this.icon.textContent = isOpen ? '\u2013' : '+';
      }

      if (isOpen) {
        // Restart from 0% so the fill always animates in (matches prototype feel).
        this.setBarWidths(false);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.setBarWidths(true));
        });
      } else {
        this.setBarWidths(false);
      }
    };
  }

  customElements.define('fabric-attributes', FabricAttributes);
}
